<template>
  <transition
    name="modal-transition"
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
    :duration="200"
  >
    <div
      class="modal fade text-left active-modal"
      tabindex="-1"
      role="dialog"
      ref="dialog"
      v-on:click="away"
    >
      <div class="modal-dialog" role="document" :class="{ 'modal-lg': large }">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="title"></slot>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </transition>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },

    large: {
      type: Boolean,
      default: false
    },

    fireEvent: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    away($event) {
      if (
        this.fireEvent &&
        $event.target == document.querySelector('div.modal.fade.active-modal')
      ) {
        this.$emit('close');
      }
    }
  },

  beforeDestroy() {
    window.$(this.$refs.dialog).modal('hide');
  },

  watch: {
    show: {
      immediate: true,
      handler(display) {
        setTimeout(() => {
          if (display) {
            window.$(this.$refs.dialog).modal('show');
          } else {
            window.$(this.$refs.dialog).modal('hide');
          }
        }, 100);
      }
    }
  }
};
</script>
